import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageService } from '@core/services/storage.service';
import { Observable, throwError } from 'rxjs';

@Injectable()
export class GlobalHttpInterceptor implements HttpInterceptor {
  constructor(
    private readonly storageService: StorageService,
  ) {}

  intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
      if (
        request.url.indexOf('s3.amazonaws.com/') !== -1
      ) {
        return next.handle(request);
      }
      return next.handle(this.addAccessToken(request));
    }

    private addAccessToken(request: HttpRequest<any>): HttpRequest<any> {
        const accessToken = this.storageService.getItem(
            'fcsc-access-token'
        );

        if (!accessToken) {
            return request;
        }

        return request.clone({
            headers: request.headers.set(
                'Authorization',
                'Bearer ' + accessToken
            ),
        });
    }
}
